const personal_training = [
    {
        name: "Individual Session",
        description: "One hour training",
        long_description: "One hour training session",
        price: 65.00,
        schedule_link: "https://calendly.com/iglf/60-min-personal-training-session"
    }
]

const metabolic_testing = [
    {
        name: "Inbody Body Composition Analysis",
        description: "Body comp analysis",
        long_description: "Understand your unique body composition with this analysis",
        price: 20.00,
        schedule_link: "https://calendly.com/iglf/metabolic-test-inbody-body-composition"
    },
    {
        name: "Resting Metabolic Rate",
        description: "Caloric requirement test",
        long_description: "Understand your body's specific caloric requirements with an RMR test",
        price: 125.00,
        schedule_link: "https://calendly.com/iglf/metabolic-testing-rmr"
    },
    {
        name: "VO2 Max",
        description: "Cardio/Endurance Fitness",
        long_description: "Cardiovascular Fitness and Aerobic Endurance test",
        price: 129.00,
        schedule_link: "https://calendly.com/iglf/metabolic-testing-vo2-max"
    },
]

const nutrition_sessions = [
    {
        name: "60 Minute Nutrition Consultation",
        description: "First Consultation",
        long_description: "This session is designed for the first time client. The outcome of working with our Registered Dietitian is to teach you how to sustainably meet your nutrition goals and to provide you with the tools and knowledge you need to continue to improve yourself when you have completed the counseling. There are no cookie cutter meal plans, off-limit foods, or magic supplements. She will provide the necessary education to set you up for success while still incorporating all macro nutrients in your diet",
        price: 100.00,
        schedule_link: "https://calendly.com/iglf/60min-nutrition"
    },
    {
        name: "30 Minute Nutrition Consultation",
        description: "Additional Consultation",
        long_description: "This session is designed for the client who has attended the 60 minute session and would like additional assistance. The session will address client questions and brainstorm solutions for challenges the client is experiencing in making dietary changes.",
        price: 55.00,
        schedule_link: "https://calendly.com/iglf/30min-nutrition"
    },
    {
        name: "15 Minute Nutrition Consultation",
        description: "Follow Up Consultation",
        long_description: "This session is for clients who have worked with our Nutritionist and would like to have regular follow up sessions. The goal is to increase sustained life-style change through accountability.",
        price: 30.00,
        schedule_link: "https://calendly.com/iglf/15min-nutrition"
    },
]

const test_items = [
    {
        name: "Test Item 1",
        description: "Test item #1",
        long_description: "This test links to 60min-nutrition",
        price: 0.01,
        schedule_link: "https://calendly.com/iglf/60min-nutrition"
    },
    {
        name: "Test Item 2",
        description: "Test item #2",
        long_description: "This test links to 30min-nutrition",
        price: 0.01,
        schedule_link: "https://calendly.com/iglf/30min-nutrition"
    },
]


export { personal_training, metabolic_testing, nutrition_sessions, test_items };